import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, withKeys as _withKeys, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d1860b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mr--30" }
const _hoisted_3 = {
  key: 0,
  class: "modal__content-btn center allBlockWidth"
}

import { nextTick, onBeforeUnmount, ref, toRefs, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    showModal: { type: Boolean },
    closeOutside: { type: Boolean },
    showCloseIcon: { type: Boolean, default: true },
    fullScreen: { type: Boolean },
    title: {},
    showPadding: { type: Boolean, default: true },
    showTitlePadding: { type: Boolean, default: true },
    transparent: { type: Boolean },
    customModal: { type: Boolean, default: false },
    withBackground: { type: Boolean, default: true },
    hideScroll: { type: Boolean, default: true },
    hideTitle: { type: Boolean }
  },
  emits: ['close'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;
const show = ref(false);
const closeModal = () => {
  emit('close');
};

const closeModalIfBackgroundClicked = (event: Event) => {
  if (!props.closeOutside) {
    return;
  }
  if (event.target === event.currentTarget) {
    closeModal();
  }
};
const targetOne = ref<HTMLElement | undefined>();
const dialog = ref<HTMLElement | undefined>();

const { showModal } = toRefs(props);

watch(showModal, isOpen => {
  if (props.hideScroll) {
    document.body.classList[isOpen ? 'add' : 'remove']('overflow-hidden');
  }
  if (props.showModal) {
    nextTick(() => {
      dialog.value.focus();
    });
  }
});
onBeforeUnmount(() => {
  if (props.hideScroll) {
    document.body.classList.remove('overflow-hidden');
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_divider = _resolveComponent("base-divider")!
  const _component_base_icon = _resolveComponent("base-icon")!

  return (_unref(showModal))
    ? (_openBlock(), _createBlock(_Teleport, {
        key: 0,
        to: "#modalWindow"
      }, [
        _createElementVNode("dialog", {
          class: "modal",
          onClick: closeModalIfBackgroundClicked
        }, [
          _createElementVNode("div", {
            ref_key: "dialog",
            ref: dialog,
            tabindex: "0",
            onKeydown: _withKeys(closeModal, ["esc"])
          }, [
            (_ctx.customModal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _renderSlot(_ctx.$slots, "content")
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass([{ fullScreen: _ctx.fullScreen, transparent: _ctx.transparent, withBackground: _ctx.withBackground }, "modal__content"])
                }, [
                  (!_ctx.$slots.title && _ctx.withBackground && !_ctx.hideTitle)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass([{ showTitlePadding: _ctx.showTitlePadding }, "modal__content-title m-font-size"])
                      }, _toDisplayString(_ctx.title), 3))
                    : _createCommentVNode("", true),
                  (!_ctx.$slots.title)
                    ? (_openBlock(), _createBlock(_component_base_divider, { key: 1 }))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "title")
                  ]),
                  _createElementVNode("div", {
                    ref_key: "targetOne",
                    ref: targetOne,
                    class: _normalizeClass([{ showPadding: _ctx.showPadding, hideTitle: _ctx.hideTitle }, "modal__content-box items-in-column"])
                  }, [
                    _renderSlot(_ctx.$slots, "content"),
                    _renderSlot(_ctx.$slots, "bottom-box"),
                    (_ctx.$slots.btn)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                          _renderSlot(_ctx.$slots, "btn")
                        ]))
                      : _createCommentVNode("", true)
                  ], 2),
                  (_ctx.showCloseIcon)
                    ? (_openBlock(), _createBlock(_component_base_icon, {
                        key: 2,
                        class: "modal__content-closeIcon",
                        clickable: "",
                        color: "black",
                        height: "15",
                        name: "close",
                        width: "15",
                        onClick: closeModal
                      }))
                    : _createCommentVNode("", true)
                ], 2))
          ], 544)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})